module.exports = __webpack_public_path__ + "static/media/app-store-1.d871fa92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app-store-1.png
// module id = 3786
// module chunks = 0